import { Sound } from './Sound';

type TSoundConfig = Record<string, { url: string }>;
type TSoundsMap<TConfig extends TSoundConfig> = {
  [TName in keyof TConfig]: Sound;
};

export class SoundService<TConfig extends TSoundConfig> {
  private readonly sounds: TSoundsMap<TConfig> = {} as TSoundsMap<TConfig>;

  isNotified = false;

  constructor(
    private config: TConfig,
    private onNoActionsOnPage: () => void,
  ) {}

  getSound<TName extends keyof TConfig>(name: TName): Sound {
    if (!this.sounds[name]) {
      this.sounds[name] = new Sound(this.config[name].url);
    }
    return this.sounds[name];
  }

  playSound<TName extends keyof TConfig>(name: TName): Promise<void> {
    return this.getSound(name)
      .play()
      .catch(() => {
        if (!this.isNotified) {
          this.onNoActionsOnPage();

          this.isNotified = true;
        }
      });
  }

  stopSound<TName extends keyof TConfig>(name: TName): void {
    this.getSound(name).stop();
  }
}
